import { gql } from 'apollo'
import { ITag, ITagPickerProps, TagPicker } from 'office-ui-fabric-react'
import * as React from 'react'
import { useApolloClient } from 'react-apollo-hooks'
import { OrderIdsQuery } from './typings/OrderIdsQuery'

const GET_ORDER_IDS = gql`
  query OrderIdsQuery {
    orderIds(validOnly: true, filter: { inactive: { NEQ: true } }) {
      value
    }
  }
`
export type OrderIdPickerProps = Omit<
  ITagPickerProps,
  'onResolveSuggestions'
> & {
  validOnly?: boolean
  blacklist?: string[]
  initialValues?: string[]
}
export const OrderIdPicker: React.FunctionComponent<OrderIdPickerProps> = (
  props
) => {
  const client = useApolloClient()
  const resolveOrderIds = async (filter: string) => {
    let initialOrderIds: ITag[] = []
    if (props.initialValues) {
      initialOrderIds = props.initialValues.map(
        (x) => ({ key: x, name: x } as ITag)
      )
    } else {
      if (filter.length > 2) {
        const result = await client.query<OrderIdsQuery>({
          query: GET_ORDER_IDS,
          fetchResults: true,
          variables: { filter },
        })
        initialOrderIds = result.data.orderIds.map(
          (x) => ({ key: x!.value, name: x!.value } as ITag)
        )
      }
    }

    const filteredInitialOrderIds = initialOrderIds.filter(
      (x) => props.blacklist && props.blacklist.indexOf(x.name) === -1
    )

    return filteredInitialOrderIds.filter((x) =>
      filter
        ? x.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1
        : true && props.blacklist
        ? props.blacklist.indexOf(x.name) === -1
        : true
    )
  }

  return (
    <TagPicker
      onResolveSuggestions={resolveOrderIds}
      onEmptyInputFocus={() => resolveOrderIds('')}
      {...props}
    />
  )
}
